import { VStack } from '@chakra-ui/react'
import { useAuth } from '@hb/react'
import { db, ProfilePicturePopover, SimpleForm, useUpdateDoc } from '@hb/react-web'
import { FieldMapValue, patientField, USERS } from '@hb/shared'
import { FORM_ERROR } from 'final-form'
import { collection, doc } from 'firebase/firestore'
import { useCallback, useMemo } from 'react'

export const PatientDataForm = () => {
  const user = useAuth(s => s.user)
  const authUser = useAuth(s => s.authUser)
  const { uid } = authUser ?? {}
  const { fname, lname, phone, dob, voicemailOk, textOk, nickname, createdOn } = user ?? {}
  const update = useUpdateDoc('your profile')
  const handleSubmit = useCallback(
    async (data: FieldMapValue) => {
      if (!uid) return { [FORM_ERROR]: 'No user id found' }
      const submitted = { ...data }
      if (!createdOn) submitted.createdOn = Date.now()
      try {
        const { error } = await update(doc(collection(db, USERS), uid), '', submitted)
        if (error) return { [FORM_ERROR]: error }
        return undefined
      } catch (err: any) {
        console.error({ err })
        return {
          [FORM_ERROR]: err?.message ?? 'There was an error updating your data',
        }
      }
    },
    [createdOn, update, uid],
  )

  const formValue = useMemo(
    () => ({
      fname,
      lname,
      phone,
      dob,
      id: uid,
      voicemailOk,
      textOk,
      nickname,
    }),
    [fname, lname, phone, dob, uid, voicemailOk, textOk, nickname],
  )

  return (
    <VStack width="100%" maxW="800px">
      <ProfilePicturePopover userId={uid} canEdit size={20} noOnlineIndicator />
      <SimpleForm theme="detailed" onSubmit={handleSubmit} value={formValue} field={patientField} />
    </VStack>
  )
}
